var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.235,
    height: 24.784,
    viewBox: "0 0 23.235 24.784",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download",
    transform: "translate(-16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_29",
    "data-name": "Groupe 29",
    transform: "translate(21.421)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_28",
    "data-name": "Groupe 28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_230",
    "data-name": "Trac\\xE9 230",
    d: "M140.321,11.3a.773.773,0,0,0-.7-.454h-3.1V.775A.775.775,0,0,0,135.743,0h-3.1a.775.775,0,0,0-.775.775V10.843h-3.1a.774.774,0,0,0-.582,1.284l5.422,6.2a.773.773,0,0,0,1.165,0l5.422-6.2A.772.772,0,0,0,140.321,11.3Z",
    transform: "translate(-127.998 0)",
    fill: "#131829"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_31",
    "data-name": "Groupe 31",
    transform: "translate(16 17.039)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_30",
    "data-name": "Groupe 30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_231",
    "data-name": "Trac\\xE9 231",
    d: "M36.137,352v4.647H19.1V352H16v6.2a1.549,1.549,0,0,0,1.549,1.549H37.686a1.548,1.548,0,0,0,1.549-1.549V352Z",
    transform: "translate(-16 -352)",
    fill: "#131829"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.41f4dc3f42ffbe83f2adf2a679d88506.svg";
export { ForwardRef as ReactComponent };